const isConsideredMobile = (state = true, action) => {
  switch (action.type) {
      case 'IS_CONSIDERED_MOBILE':
          return action.mobile
      default:
          return state
  }
}

export default isConsideredMobile;